/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useRef } from "react";
import * as Yup from "yup";
import Page from "components/common_components/Page";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Button from "components/common_components/Button";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo, notifySuccess, notifyWarning } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Status from "components/common_components/Status";
import Icon from "components/common_components/Icon";
import { ConfirmDialog, FormDialog } from "components/common_components/Dialogs";
import ChainOfCustodyContext from "./ChainOfCustodyContext";
import Header from "components/common_components/Header";
import { hasElements, removeDuplicates } from "utils/arrays";
import clsx from "clsx";
import { dateToFullString, isDateValid } from "utils/dateUtils";
import { getDownloadURL } from "firebase/storage";
import Link from "components/common_components/Link";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator,
} from "@material-ui/lab";
import { Form, InputField, SelectField, TextareaField } from "components/common_components/Formik";
import { Tabs } from "components/common_components/Tabs";
import { Checkbox, FormControlLabel, Grid, MenuItem, TextField } from "@material-ui/core";
import { sanitizeFileName } from "utils/files";
import useFilesUploader, { FileTypes } from "components/common_components/hooks/useFilesUploader/useFilesUploader";
import attachmentOrigins from "utils/static/attachmentOrigins";
import RichTextEditor from "components/common_components/RichTextEditor/RichTextEditor";
import { Field } from "formik";
import { getFieldError } from "components/common_components/Formik/hooks/fieldUtils";
import SVGIconPDF from "./components/SVGIconPDF";
import SVGIconFile from "./components/SVGIconFile";
import { getAnalysisDocs, getEvidenceDocs } from "./utils/utils";

const ActivityActions = {
    ADD_DOCUMENT: "Document added",
    ADD_DOCUMENTS: "Documents added",
    DELETE_DOCUMENT: "Document deleted",
    MARK_RECEIVED: "Received",
    UNMARK_RECEIVED: "Received mark removed",
    APPROVED: "Approved",
    APPROVAL_REVOKED: "Approval revoked",
    ANALYSIS_ADDED: "Analysis added",
    ANALYSIS_ATTACHMENT_ADDED: "Analysis attachment added",
    ANALYSIS_ATTACHMENTS_ADDED: "Analysis attachments added",
    STATUS_CHANGED: "Status changed",
    REQUESTED_TO_CLIENT: "Requested to client",
    UNREQUESTED_TO_CLIENT: "Request to client removed",
};

const CocRequest = ({ mode, onCancel }) => {
    const viewMode = mode === "view";
    const editMode = mode === "edit";
    const { id } = useParams();
    const { user } = useSelector((state) => state.Login);
    const history = useHistory();
    const { url } = useRouteMatch();
    const quillRef = useRef();
    const dispatch = useDispatch();
    const [statusFilter, setStatusFilter] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [addingEvidence, setAddingEvidence] = useState(false);
    const [resources, setResources] = useState({
        evidenceTypes: [],
    });
    const [loaders, setLoaders] = useState({
        evidences: {
            setStatus: false,
            approve: false,
            revokeApproval: false,
            markReceived: false,
            unmarkReceived: false,
            requestToClient: false,
            unrequestToClient: false,
            delete: false,
        },
    });
    const [cocRequest, setCocRequest] = useState(undefined);
    const {
        CocRequests,
        Evidences,
        EvidenceDocs,
        EvidenceActivity,
        EvidenceAnalysis,
        EvidenceApprovals,
        Storage,
        permissions,
        setStatus,
        EvidenceTypes,
        fileCaseFilter,
    } = useContext(ChainOfCustodyContext);
    const [openContainers, setOpenContainers] = useState([]);
    const [filesToUpload, fileNames, fileOrigins, reset, uploader] = useFilesUploader({ requestOrigin: true });
    const [filesToUpload_analysis, fileNames_analysis, fileOrigins_analysis, reset_analysis, uploader_analysis] = useFilesUploader({
        requestOrigin: false,
    });
    const [isUploading, setIsUploading] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [evidenceGroups, setEvidenceGroups] = useState([]);
    const [confirmDialogProps, setConfirmDialogProps] = useState({
        open: false,
        title: "",
        content: "",
        primaryButtonText: "",
        onPrimaryClick: undefined,
        secondaryButtonText: "Cancel",
        onSecondaryClick: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
        onClose: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
    });
    const [formDialogProps, setFormDialogProps] = useState({
        open: false,
        title: "",
        formId: "in-dialog-form",
        isSubmitting: false,
        onClose: () => setFormDialogProps((prev) => ({ ...prev, open: false, isSubmitting: false })),
    });

    const setRequestStatus = async (id, status) => {
        if (status === "completed") {
            setConfirmDialogProps((prev) => ({
                ...prev,
                open: true,
                title: "Complete request",
                content: "Are you sure you want to complete this request? You will not be able to edit it anymore.",
                primaryButtonText: "Yes, complete",
                onPrimaryClick: () => {
                    setStatus(id, status, () => {
                        getCocRequest();
                    });
                    prev.onClose();
                },
            }));
        } else {
            setStatus(id, status, () => {
                getCocRequest();
            });
        }
    };

    const getResources = () => {
        setIsLoading(true);
        EvidenceTypes.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    evidenceTypes: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({ ...prev, evidenceTypes: [] }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getResources();
    }, []);

    const getCocRequest = () => {
        setIsLoading(true);
        CocRequests.getOneById({
            id,
            onSuccess,
            onError,
        });
    };

    useEffect(() => {
        if (id) {
            getCocRequest();
        } else {
            dispatch(notifyError("No ID included in the path."));
            setCocRequest(undefined);
            onCancel();
        }

        return () => setCocRequest(undefined);
    }, [id]);

    const onSuccess = (data) => {
        setCocRequest(data);
        setEvidenceGroups(data.evidences.map((evidence) => evidence.cocEvidenceDocType.type));
        setIsLoading(false);
    };

    const onError = (error) => {
        dispatch(notifyError(error.message || error));
        setIsLoading(false);
        onCancel();
    };

    const onEditHandler = () => {
        history.push(`${url}/edit`);
    };

    const isContainerOpen = (id) => openContainers.includes(id);
    const toggleContainer = (id) => {
        if (isContainerOpen(id)) {
            setOpenContainers((prev) => prev.filter((containerId) => containerId !== id));
        } else {
            setOpenContainers((prev) => [...prev, id]);
        }
    };

    const onUploadHandler = async (
        evidence,
        filesToUpload,
        fileNames,
        fileOrigins,
        defaultFileOrigin = null,
        logInfo = { single: ActivityActions.ADD_DOCUMENT, multiple: ActivityActions.ADD_DOCUMENTS }
    ) => {
        const requests = [];

        filesToUpload.forEach((file) => {
            const request = new Promise(async (resolve, reject) => {
                const customName = fileNames[file.name] || file.name;
                const origin = fileOrigins[file.name] || defaultFileOrigin;
                if (!origin) {
                    reject({ httpError: undefined, data: file, message: `Origin is required for the file ${customName}` });
                    return;
                }
                try {
                    const fileExtension = `.${file.name.split(".").pop()}`;
                    const fileName = sanitizeFileName(customName.replace(fileExtension, ""));
                    const snap = await Storage.uploadAsync({
                        path: `chain-of-custody/requests/${id}/evidences/${evidence.id}/docs/${fileName}${fileExtension}`,
                        file,
                    });
                    const url = await getDownloadURL(snap.ref);
                    const response = await EvidenceDocs.addAsync(id, {
                        id: null,
                        cocRequestEvidencesId: evidence.id,
                        docName: fileName,
                        docExtension: fileExtension,
                        docStorageUrl: url,
                        storedUserId: user.id,
                        storedDatetime: new Date().getTime(),
                        origin,
                    });
                    if (response && response.status === 200) {
                        resolve({ ...response, fileName: `${fileName}${fileExtension}`, origin });
                    } else {
                        reject({ httpError: undefined, data: file, message: `Error uploading the file ${customName}` });
                    }
                } catch (error) {
                    reject({ httpError: error, data: file, message: `Error uploading the file ${customName}` });
                }
            });

            requests.push(request);
        });

        if (requests.length > 0) {
            setIsUploading(true);
            Promise.all(requests)
                .then((responses) => {
                    dispatch(notifySuccess(`Uploaded successfully!`));
                    cancelAttachFile();
                    silentSaveEvidenceActivity(
                        evidence.id,
                        responses.length > 1 ? logInfo.multiple : logInfo.single,
                        `\t- ${responses
                            .map(
                                (r) => `${r.fileName} | Origin: ${attachmentOrigins.find((ao) => ao.value === r.origin)?.label || r.origin}`
                            )
                            .join("\n\t- ")}`
                    );
                })
                .catch((error) => {
                    dispatch(notifyError(error.message));
                })
                .finally(() => {
                    setIsUploading(false);
                });
        }
    };

    function cancelAttachFile() {
        reset();
        reset_analysis();
    }

    const silentSaveEvidenceActivity = async (evidenceId, action, notes) => {
        try {
            await EvidenceActivity.addAsync(id, {
                id: null,
                cocRequestEvidencesId: evidenceId,
                action,
                notes,
                actionUserId: user.id,
                actionDatetime: new Date().getTime(),
            });
        } catch (error) {
            console.error("Error saving evidence activity:", error);
        } finally {
            getCocRequest();
        }
    };

    const onSubmitActivityHandler = (values, { setSubmitting, setErrors }, evidence) => {
        const { action, notes } = values;

        EvidenceActivity.addAsync(id, {
            id: null,
            cocRequestEvidencesId: evidence.id,
            action,
            notes,
            actionUserId: user.id,
            actionDatetime: new Date().getTime(),
        })
            .then(() => {
                dispatch(notifySuccess("Activity added successfully!"));
                setSubmitting(false);
                getCocRequest();
            })
            .catch((error) => {
                if (error && error.errors) {
                    setErrors(error.errors);
                    dispatch(notifyError(error.message));
                } else {
                    dispatch(notifyError(error));
                }
                setSubmitting(false);
            });
    };

    const markEvidenceAsReceived = (evidenceId) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Mark evidence as received",
            content: "Are you sure you want to mark this evidence as received?",
            primaryButtonText: "Yes, mark as received",
            onPrimaryClick: async () => {
                try {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, markReceived: true } }));
                    await Evidences.markEvidenceAsReceivedAsync(id, evidenceId);
                    dispatch(notifySuccess("Evidence marked as received successfully!"));
                    silentSaveEvidenceActivity(evidenceId, ActivityActions.MARK_RECEIVED, "Evidence marked as received.");
                } catch (error) {
                    const message = error.response?.data?.message || error.message || "Unexpected error.";
                    dispatch(notifyError(message));
                } finally {
                    prev.onClose();
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, markReceived: false } }));
                }
            },
        }));
    };

    const unmarkEvidenceAsReceived = (evidenceId) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Unmark received evidence",
            content: "This evidence has been marked as received. Are you sure you want to unmark it?",
            primaryButtonText: "Yes, unmark received",
            onPrimaryClick: async () => {
                try {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, unmarkReceived: true } }));
                    await Evidences.unmarkEvidenceAsReceivedAsync(id, evidenceId);
                    dispatch(notifyWarning("Received evidence unmarked successfully!"));
                    silentSaveEvidenceActivity(evidenceId, ActivityActions.UNMARK_RECEIVED, "Received evidence unmarked.");
                } catch (error) {
                    const message = error.response?.data?.message || error.message || "Unexpected error.";
                    dispatch(notifyError(message));
                } finally {
                    prev.onClose();
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, unmarkReceived: false } }));
                }
            },
        }));
    };

    const requestEvidenceToClient = (evidenceId) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Request to client",
            content: "Are you sure you want to request this evidence document to the client?",
            primaryButtonText: "Yes, request to client",
            onPrimaryClick: async () => {
                try {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, requestToClient: true } }));
                    await Evidences.requestToClientAsync(id, evidenceId);
                    dispatch(notifySuccess("Evidence requested to client successfully!"));
                    silentSaveEvidenceActivity(evidenceId, ActivityActions.REQUESTED_TO_CLIENT, "Evidence document requested to client.");
                } catch (error) {
                    const message = error.response?.data?.message || error.message || "Unexpected error.";
                    dispatch(notifyError(message));
                } finally {
                    prev.onClose();
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, requestToClient: false } }));
                }
            },
        }));
    };

    const unrequestEvidenceToClient = (evidenceId) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Remove request to client",
            content: "Are you sure you want to remove the request to client for this evidence?",
            primaryButtonText: "Yes, remove request",
            onPrimaryClick: async () => {
                try {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, unrequestToClient: true } }));
                    await Evidences.unrequestToClientAsync(id, evidenceId);
                    dispatch(notifyWarning("Request to client removed successfully!"));
                    silentSaveEvidenceActivity(evidenceId, ActivityActions.UNREQUESTED_TO_CLIENT, "Request to client removed.");
                } catch (error) {
                    const message = error.response?.data?.message || error.message || "Unexpected error.";
                    dispatch(notifyError(message));
                } finally {
                    prev.onClose();
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, unrequestToClient: false } }));
                }
            },
        }));
    };

    const getEvidenceStatusOptions = (evidence) => [
        {
            value: "open",
            preconditions: () => permissions.requests.evidences.status.open,
            confirmationDialog: {
                show: true,
                title: "Open evidence",
                content: "Are you sure you want to open this evidence?",
                primaryButtonText: "Yes, open",
            },
            successMessage: "Evidence opened successfully!",
            log: {
                action: ActivityActions.STATUS_CHANGED,
                message: "Evidence opened.",
            },
        },
        {
            value: "inprogress",
            preconditions: () => permissions.requests.evidences.status.inprogress,
            confirmationDialog: {
                show: true,
                title: "In Progress evidence",
                content: "Are you sure you want to set this evidence as in progress?",
                primaryButtonText: "Yes, in progress",
            },
            successMessage: "Evidence set as in progress successfully!",
            log: {
                action: ActivityActions.STATUS_CHANGED,
                message: "Evidence set as in progress.",
            },
        },
        {
            value: "completed",
            preconditions: () => evidence.received && permissions.requests.evidences.status.complete,
            confirmationDialog: {
                show: true,
                title: "Complete evidence",
                content: "Are you sure you want to complete this evidence? You will not be able to edit it anymore.",
                primaryButtonText: "Yes, complete",
            },
            successMessage: "Evidence completed successfully!",
            log: {
                action: ActivityActions.STATUS_CHANGED,
                message: "Evidence completed.",
            },
        },
        {
            value: "rejected",
            preconditions: () => permissions.requests.evidences.status.reject,
            confirmationDialog: {
                show: true,
                title: "Reject evidence",
                content: "Are you sure you want to reject this evidence?",
                primaryButtonText: "Yes, reject",
                needsComment: true,
            },
            successMessage: "Evidence rejected successfully!",
            log: {
                action: ActivityActions.STATUS_CHANGED,
                message: "Evidence rejected.",
            },
        },
    ];

    const onEvidenceStatusChange = (evidence, status) => {
        const selectedOption = getEvidenceStatusOptions(evidence).find((option) => option.value === status);
        if (!selectedOption) return;
        const execute = async (dialogProps, statusComment) => {
            try {
                setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, setStatus: true } }));
                await Evidences.changeEvidenceStatusAsync(id, evidence.id, status);
                dispatch(notifySuccess(selectedOption.successMessage));
                silentSaveEvidenceActivity(
                    evidence.id,
                    selectedOption.log.action,
                    `${selectedOption.log.message} \n${statusComment || ""}`
                );
            } catch (error) {
                const message = error.response?.data?.message || error.message || "Unexpected error.";
                dispatch(notifyError(message));
            } finally {
                dialogProps?.onClose();
                setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, setStatus: false } }));
            }
        };
        if (selectedOption.confirmationDialog && selectedOption.confirmationDialog.show) {
            setConfirmDialogProps((prev) => ({
                ...prev,
                open: true,
                title: selectedOption.confirmationDialog.title,
                content: selectedOption.confirmationDialog.content,
                primaryButtonText: selectedOption.confirmationDialog.primaryButtonText,
                onPrimaryClick: async () => {
                    if (selectedOption.confirmationDialog.needsComment) {
                        setFormDialogProps((prevF) => ({
                            ...prevF,
                            open: true,
                            title: "Provide a comment",
                            onSubmit: async (values, { resetForm }) => {
                                const { statusComment } = values;
                                setFormDialogProps((prev) => ({ ...prev, isSubmitting: true }));
                                await execute(prev, statusComment);
                                resetForm();
                                prevF.onClose();
                            },
                        }));
                    } else {
                        await execute(prev);
                    }
                },
            }));
        } else {
            execute();
        }
    };

    const isEvidenceApprovedByCurrentUser = (evidence) => {
        return (
            hasElements(evidence.approvals) &&
            evidence.approvals.some((approval) => approval.userId === user.id && Boolean(approval.approved))
        );
    };

    const approveEvidence = async (evidence) => {
        try {
            setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, approve: true } }));
            const approvalId = hasElements(evidence.approvals) && evidence.approvals.find((x) => x.userId === user.id)?.id;
            const apiCall = approvalId ? EvidenceApprovals.updateAsync : EvidenceApprovals.addAsync;
            await apiCall(id, {
                id: approvalId || null,
                cocRequestEvidencesId: evidence.id,
                approved: true,
                datetime: new Date().getTime(),
                userId: user.id,
            });
            dispatch(notifySuccess("You approved the evidence successfully!"));
            silentSaveEvidenceActivity(evidence.id, ActivityActions.APPROVED, "Evidence has been approved.");
        } catch (error) {
            dispatch(notifyError(error.message));
        } finally {
            setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, approve: false } }));
        }
    };

    const unapproveEvidence = async (evidence) => {
        try {
            setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, revokeApproval: true } }));
            const approvalId = hasElements(evidence.approvals) && evidence.approvals.find((x) => x.userId === user.id)?.id;
            if (!approvalId) {
                dispatch(notifyError("Approval not found."));
                return;
            }
            await EvidenceApprovals.updateAsync(id, {
                id: approvalId,
                cocRequestEvidencesId: evidence.id,
                approved: false,
                datetime: new Date().getTime(),
                userId: user.id,
            });
            dispatch(notifyInfo("Approval revoked successfully!"));
            silentSaveEvidenceActivity(evidence.id, ActivityActions.APPROVAL_REVOKED, "Evidence approval has been revoked.");
        } catch (error) {
            dispatch(notifyError(error.message));
        } finally {
            setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, revokeApproval: false } }));
        }
    };

    const deleteEvidence = async (evidence) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Delete evidence",
            content:
                "Are you sure you want to delete this evidence and all its progress? Documents, Activity, Analysis, and Approvals will be deleted.",
            primaryButtonText: "Yes, delete",
            onPrimaryClick: async () => {
                try {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, delete: true } }));
                    await Evidences.deleteAsync(id, evidence.id);
                    dispatch(notifySuccess("Evidence deleted successfully!"));
                    getCocRequest();
                } catch (error) {
                    dispatch(notifyError(error.message));
                } finally {
                    setLoaders((prev) => ({ ...prev, evidences: { ...prev.evidences, delete: false } }));
                    prev.onClose();
                }
            },
        }));
    };

    const onDeleteDocHandler = (evidence, doc) => {
        setConfirmDialogProps((prev) => ({
            ...prev,
            open: true,
            title: "Delete document",
            content: "Are you sure you want to delete this document?",
            primaryButtonText: "Yes, delete",
            onPrimaryClick: async () => {
                try {
                    await EvidenceDocs.deleteAsync(id, evidence.id, doc.id);
                    dispatch(notifySuccess("Document deleted successfully!"));
                    await silentSaveEvidenceActivity(evidence.id, ActivityActions.DELETE_DOCUMENT, `\t- ${doc.docName}${doc.docExtension}`);
                    Storage.deleteAsync({
                        path: `chain-of-custody/requests/${id}/evidences/${evidence.id}/docs/${doc.docName}${doc.docExtension}`,
                    });
                } catch (error) {
                    dispatch(notifyError(error.message));
                } finally {
                    prev.onClose();
                }
            },
        }));
    };

    const onSubmitAnalysisHandler = (values, { setSubmitting, setErrors }, evidence) => {
        const { area, notes } = values;

        EvidenceAnalysis.addAsync(id, {
            id: null,
            cocRequestEvidencesId: evidence.id,
            area,
            notes: JSON.stringify(notes),
            userId: user.id,
            datetime: new Date().getTime(),
        })
            .then(() => {
                dispatch(notifySuccess("Analysis added successfully!"));
                setSubmitting(false);
                silentSaveEvidenceActivity(
                    evidence.id,
                    ActivityActions.ANALYSIS_ADDED,
                    "A new analysis of the evidence was reported."
                );
            })
            .catch((error) => {
                if (error && error.errors) {
                    setErrors(error.errors);
                    dispatch(notifyError(error.message));
                } else {
                    dispatch(notifyError(error));
                }
                setSubmitting(false);
            });
    };

    const openedTab = useRef(null);
    const onOpenCaseHandler = () => {
        if (openedTab.current && !openedTab.current.closed) {
            openedTab.current.focus();
        } else {
            openedTab.current = window.open(`/${cocRequest.module}?fileCaseId=${cocRequest.fileCaseId}`, "_blank");
        }
    };

    const filterByStatus = (status) => {
        setStatusFilter(status);
    };

    return (
        <Page className="coc-page">
            {isLoading ? (
                <LoadingPage />
            ) : (
                cocRequest && (
                    <>
                        <div className="form-head">
                            <div className="item back">
                                <Button secondary link small onClick={onCancel}>
                                    <Icon name="arrow" size="sm" color="secondary" />
                                    <span>Back</span>
                                </Button>
                            </div>
                            <div className="item form-status">
                                <TextField
                                    select
                                    value={cocRequest.status}
                                    onChange={(e) => setRequestStatus(cocRequest.id, e.target.value)}
                                    size="small"
                                    className={"status-select"}
                                    SelectProps={{ renderValue: (value) => <Status id={value} withIcon /> }}
                                >
                                    {["pending", "inprogress", "completed"].map((value, index) => (
                                        <MenuItem value={value} key={index}>
                                            {loaders.evidences.setStatus && <div className="icon icon--loading loading" />}
                                            <Status id={value} withIcon />
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="item">
                                {`Exp. ${cocRequest.dueDateString}`}
                                {cocRequest.dueDateNotificationProcessed && <Icon name="warning" color="warning" size="md" />}
                            </div>
                            <div className="item">{cocRequest.cocRequestType?.type}</div>
                            {!fileCaseFilter && (
                                <>
                                    <div className="item">{cocRequest.client?.fullName}</div>
                                    {cocRequest.module && (
                                        <div className="item">
                                            <Button secondary small onClick={onOpenCaseHandler}>
                                                <span>{cocRequest.fileNo}</span>
                                                <Icon name="open-new-tab" color="white" size="sm" />
                                            </Button>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className="item form-actions">
                                {viewMode && permissions.requests.edit && cocRequest.status !== "completed" && (
                                    <Button secondary small onClick={onEditHandler}>
                                        <Icon name="pencil" size="md" color="white" />
                                        <span>Edit</span>
                                    </Button>
                                )}
                            </div>
                        </div>
                        <Header title="Evidences">
                            <Button secondary onClick={() => setAddingEvidence(true)} disabled={!permissions.requests.evidences.add}>
                                <Icon name="add" size="sm" color="white" />
                                <span>Add</span>
                            </Button>
                        </Header>

                        <div className="filters">
                            {removeDuplicates(cocRequest.evidences.map((evidence) => evidence.status)).map((status) => (
                                <Button
                                    secondary
                                    outline
                                    onClick={() => filterByStatus(status)}
                                    className={clsx(`status-${status}`, { selected: statusFilter === status })}
                                    key={status}
                                >
                                    <div className="status-btn-content">
                                        <span className="count">
                                            {cocRequest.evidences.filter((evidence) => evidence.status === status).length}
                                        </span>
                                        <Status id={status} />
                                        {statusFilter === status && (
                                            <Button
                                                small
                                                secondary
                                                outline
                                                onClick={() => filterByStatus(undefined)}
                                                className="status-clear"
                                            >
                                                <Icon name="cancel" size="xxs" color="secondary" />
                                            </Button>
                                        )}
                                    </div>
                                </Button>
                            ))}
                        </div>

                        <div className="evidences-container">
                            {addingEvidence && (
                                <div className="evidence add">
                                    <div className="evidence__header">
                                        <div className="evidence-info">
                                            <Form
                                                initialValues={{
                                                    evidenceType: "",
                                                }}
                                                showButtons={hasElements(resources.evidenceTypes)}
                                                validationSchema={Yup.object().shape({
                                                    evidenceType: Yup.string().required("Required"),
                                                })}
                                                onSubmit={async (values, { setSubmitting }) => {
                                                    const { evidenceType } = values;
                                                    setSubmitting(true);
                                                    Evidences.add({
                                                        payload: {
                                                            id: null,
                                                            requestId: id,
                                                            settingsCocEvidenceDocTypesId: evidenceType,
                                                            description: resources.evidenceTypes.find((x) => x.id === evidenceType)
                                                                ?.description,
                                                        },
                                                        onSuccess: (newId) => {
                                                            setAddingEvidence(false);
                                                            setSubmitting(false);
                                                            dispatch(notifySuccess("Evidence added successfully!"));
                                                            getCocRequest();
                                                        },
                                                        onError: (error) => {
                                                            dispatch(notifyError(error));
                                                            setSubmitting(false);
                                                        },
                                                    });
                                                }}
                                                onCancel={() => setAddingEvidence(false)}
                                            >
                                                {hasElements(resources.evidenceTypes) ? (
                                                    <SelectField
                                                        fieldName="evidenceType"
                                                        label="Evidence type"
                                                        options={resources.evidenceTypes}
                                                        valueKey={"id"}
                                                        labelKey={"type"}
                                                        placeholder="Select evidence type"
                                                    />
                                                ) : (
                                                    <span>No extra evidence types to add!</span>
                                                )}
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {removeDuplicates(evidenceGroups).map((group) => (
                                <div key={group} className="evidence-group-container">
                                    <h2 className="evidence-group">{group}</h2>
                                    {cocRequest.evidences
                                        .filter((x) => x.cocEvidenceDocType.type === group && (!statusFilter || x.status === statusFilter))
                                        .map((evidence) => {
                                            const evidenceDocs = getEvidenceDocs(evidence);
                                            const analysisDocs = getAnalysisDocs(evidence);
                                            return (
                                                <div key={evidence.id} className="evidence">
                                                    <div className={`evidence__header status-${evidence.status}`}>
                                                        <div className="evidence-info" onClick={() => toggleContainer(evidence.id)}>
                                                            {hasElements(evidenceDocs) ? (
                                                                <>
                                                                    <div
                                                                        className="evidence-doc"
                                                                        title={`${evidenceDocs[0].docName}${evidenceDocs[0].docExtension}`}
                                                                    >{`${evidenceDocs[0].docName}`}</div>
                                                                    <div
                                                                        className="evidence-doc-user"
                                                                        title={evidenceDocs[0].storedUser?.name}
                                                                    >
                                                                        {evidenceDocs[0].storedUser?.name}
                                                                    </div>
                                                                    <div
                                                                        className="evidence-doc-datetime"
                                                                        title={dateToFullString(evidenceDocs[0].storedDatetime)}
                                                                    >
                                                                        {dateToFullString(evidenceDocs[0].storedDatetime)}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="evidence-type">{`<${evidence.cocEvidenceDocType.type}>`}</div>
                                                                    <div className="evidence-docs-count">No document attached yet!</div>
                                                                    {!evidence.received && (
                                                                        <FormControlLabel
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={Boolean(evidence.requestedToClient)}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.checked) {
                                                                                            requestEvidenceToClient(evidence.id);
                                                                                        } else {
                                                                                            unrequestEvidenceToClient(evidence.id);
                                                                                        }
                                                                                    }}
                                                                                    disabled={
                                                                                        viewMode ||
                                                                                        !permissions.requests.edit ||
                                                                                        loaders.evidences.requestToClient ||
                                                                                        loaders.evidences.unrequestToClient
                                                                                    }
                                                                                    size="small"
                                                                                />
                                                                            }
                                                                            label="Request to client"
                                                                            className="request-to-client-check"
                                                                        />
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>

                                                        <div className="evidence-extra">
                                                            {evidence.received &&
                                                                !isEvidenceApprovedByCurrentUser(evidence) &&
                                                                permissions.requests.evidences.approve && (
                                                                    <Button
                                                                        secondary
                                                                        small
                                                                        onClick={() => approveEvidence(evidence)}
                                                                        loading={loaders.evidences.approve}
                                                                    >
                                                                        <Icon name="rounded-check" size="sm" color="white" />
                                                                        <span>Approve</span>
                                                                    </Button>
                                                                )}

                                                            {isEvidenceApprovedByCurrentUser(evidence) &&
                                                                permissions.requests.evidences.revokeApproval && (
                                                                    <Button
                                                                        secondary
                                                                        small
                                                                        onClick={() => unapproveEvidence(evidence)}
                                                                        loading={loaders.evidences.revokeApproval}
                                                                    >
                                                                        <Icon name="cancel" size="xs" color="white" />
                                                                        <span>Revoke approval</span>
                                                                    </Button>
                                                                )}
                                                            <div className="evidence-status">
                                                                <TextField
                                                                    select
                                                                    value={evidence.status}
                                                                    onChange={(e) => onEvidenceStatusChange(evidence, e.target.value)}
                                                                    size="small"
                                                                    className={"status-select"}
                                                                    SelectProps={{ renderValue: (value) => <Status id={value} withIcon /> }}
                                                                >
                                                                    {getEvidenceStatusOptions(evidence).map(
                                                                        ({ value, preconditions }, index) =>
                                                                            (preconditions() || evidence.status === value) && (
                                                                                <MenuItem value={value} key={index}>
                                                                                    {loaders.evidences.setStatus && (
                                                                                        <div className="icon icon--loading loading" />
                                                                                    )}
                                                                                    <Status id={value} withIcon />
                                                                                </MenuItem>
                                                                            )
                                                                    )}
                                                                </TextField>
                                                            </div>
                                                            {permissions.requests.evidences.delete && (
                                                                <Button
                                                                    secondary
                                                                    small
                                                                    link
                                                                    onClick={() => deleteEvidence(evidence)}
                                                                    loading={loaders.evidences.delete}
                                                                >
                                                                    <Icon name="delete" size="sm" color="secondary" />
                                                                </Button>
                                                            )}
                                                            <Button secondary link small onClick={() => toggleContainer(evidence.id)}>
                                                                <Icon
                                                                    name="arrow"
                                                                    size="sm"
                                                                    color="secondary"
                                                                    className={clsx({
                                                                        open: isContainerOpen(evidence.id),
                                                                        closed: !isContainerOpen(evidence.id),
                                                                    })}
                                                                />
                                                            </Button>
                                                        </div>
                                                    </div>

                                                    <div
                                                        className={clsx("evidence__body", {
                                                            open: isContainerOpen(evidence.id),
                                                            closed: !isContainerOpen(evidence.id),
                                                        })}
                                                    >
                                                        <div className="evidence__description">{evidence.description}</div>
                                                        <Tabs
                                                            options={[
                                                                {
                                                                    index: 0,
                                                                    label: "Document",
                                                                    icon: "attachment",
                                                                },
                                                                {
                                                                    index: 1,
                                                                    label: "Activity",
                                                                    icon: "timeline",
                                                                },
                                                                {
                                                                    index: 2,
                                                                    label: "Analysis",
                                                                    icon: "analyze",
                                                                },
                                                                {
                                                                    index: 3,
                                                                    label: "Approvals",
                                                                    icon: "rounded-check",
                                                                },
                                                            ]}
                                                            selectedOption={{ index: selectedTab }}
                                                            onChange={(_, idx) => setSelectedTab(idx)}
                                                            renderTabLabel={(label) => <span>{label}</span>}
                                                        >
                                                            <div
                                                                className={clsx("evidence__docs", {
                                                                    open: selectedTab === 0,
                                                                    closed: selectedTab !== 0,
                                                                })}
                                                            >
                                                                {permissions.requests.evidences.docs.view ? (
                                                                    <>
                                                                        <div className="title">
                                                                            <span>Document</span>
                                                                            {editMode &&
                                                                                !evidence.received &&
                                                                                hasElements(evidenceDocs) &&
                                                                                permissions.requests.evidences.docs.markReceived && (
                                                                                    <Button
                                                                                        secondary
                                                                                        outline
                                                                                        small
                                                                                        onClick={() => markEvidenceAsReceived(evidence.id)}
                                                                                        loading={loaders.evidences.markReceived}
                                                                                    >
                                                                                        <Icon
                                                                                            name="rounded-check"
                                                                                            size="sm"
                                                                                            color="success"
                                                                                        />
                                                                                        <span>Mark as received</span>
                                                                                    </Button>
                                                                                )}
                                                                            {editMode &&
                                                                                evidence.status !== "completed" &&
                                                                                evidence.received &&
                                                                                permissions.requests.evidences.docs.unmarkReceived && (
                                                                                    <Button
                                                                                        secondary
                                                                                        outline
                                                                                        small
                                                                                        onClick={() =>
                                                                                            unmarkEvidenceAsReceived(evidence.id)
                                                                                        }
                                                                                        loading={loaders.evidences.unmarkReceived}
                                                                                    >
                                                                                        <Icon name="cancel" size="xs" color="secondary" />
                                                                                        <span>Unmark received</span>
                                                                                    </Button>
                                                                                )}
                                                                        </div>
                                                                        <div className="container">
                                                                            {hasElements(evidenceDocs) ? (
                                                                                <Timeline className="timeline">
                                                                                    {evidenceDocs.map((doc) => (
                                                                                        <TimelineItem key={doc.id} className="evidence-doc">
                                                                                            <TimelineSeparator
                                                                                                style={{
                                                                                                    justifyContent: "center",
                                                                                                    paddingLeft: "10px",
                                                                                                }}
                                                                                            >
                                                                                                {doc.docExtension === ".pdf" ? (
                                                                                                    <SVGIconPDF />
                                                                                                ) : (
                                                                                                    <SVGIconFile />
                                                                                                )}
                                                                                            </TimelineSeparator>
                                                                                            <TimelineContent className="doc-content">
                                                                                                <span
                                                                                                    className="doc-name"
                                                                                                    title={`${doc.docName}${doc.docExtension}`}
                                                                                                >{`${doc.docName}${doc.docExtension}`}</span>
                                                                                                <span
                                                                                                    className="doc-user"
                                                                                                    title={doc.storedUser?.name}
                                                                                                >
                                                                                                    {doc.storedUser?.name}
                                                                                                </span>
                                                                                                <span
                                                                                                    className="doc-datetime"
                                                                                                    title={dateToFullString(
                                                                                                        doc.storedDatetime
                                                                                                    )}
                                                                                                >
                                                                                                    {dateToFullString(doc.storedDatetime)}
                                                                                                </span>
                                                                                                <span className="doc-origin">
                                                                                                    {attachmentOrigins.find(
                                                                                                        (origin) =>
                                                                                                            origin.value === doc.origin
                                                                                                    )?.label || ""}
                                                                                                </span>
                                                                                                <div className="doc-actions">
                                                                                                    {permissions.requests.evidences.docs
                                                                                                        .open && (
                                                                                                        <Link
                                                                                                            href={doc.docStorageUrl}
                                                                                                            target="_blank"
                                                                                                            title="Open file"
                                                                                                        >
                                                                                                            <Icon
                                                                                                                name="open-new-tab"
                                                                                                                color="secondary"
                                                                                                                size="sm"
                                                                                                            />
                                                                                                        </Link>
                                                                                                    )}
                                                                                                    {editMode &&
                                                                                                        !evidence.received &&
                                                                                                        permissions.requests.evidences.docs
                                                                                                            .delete && (
                                                                                                            <Button
                                                                                                                small
                                                                                                                secondary
                                                                                                                link
                                                                                                                title="Delete file"
                                                                                                                onClick={() =>
                                                                                                                    onDeleteDocHandler(
                                                                                                                        evidence,
                                                                                                                        doc
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                <Icon
                                                                                                                    name="delete"
                                                                                                                    color="secondary"
                                                                                                                    size="sm"
                                                                                                                />
                                                                                                            </Button>
                                                                                                        )}
                                                                                                </div>
                                                                                            </TimelineContent>
                                                                                        </TimelineItem>
                                                                                    ))}
                                                                                </Timeline>
                                                                            ) : (
                                                                                <span className="no-results">
                                                                                    <Icon name="no-results" size="lg" color="secondary" />
                                                                                    No evidence document found
                                                                                </span>
                                                                            )}
                                                                            {editMode &&
                                                                                !evidence.received &&
                                                                                !hasElements(evidenceDocs) &&
                                                                                permissions.requests.evidences.docs.add && (
                                                                                    <div className="add-docs">
                                                                                        <div className="add-docs__popup">
                                                                                            {/* <div className="add-docs__popup-header">
                                                                                    <span className="add-docs__popup-header-title">
                                                                                        Add new documents
                                                                                    </span>
                                                                                </div> */}
                                                                                            <div className="add-docs__popup-body">
                                                                                                {uploader({
                                                                                                    acceptedFiles: [
                                                                                                        FileTypes.PDF,
                                                                                                        FileTypes.IMAGE,
                                                                                                        FileTypes.VIDEO,
                                                                                                        FileTypes.AUDIO,
                                                                                                        FileTypes.TEXT,
                                                                                                        FileTypes.ALL,
                                                                                                    ],
                                                                                                    filesLimit: 1,
                                                                                                })}
                                                                                                {hasElements(filesToUpload) && (
                                                                                                    <Button
                                                                                                        secondary
                                                                                                        small
                                                                                                        loading={isUploading}
                                                                                                        onClick={() =>
                                                                                                            onUploadHandler(
                                                                                                                evidence,
                                                                                                                filesToUpload,
                                                                                                                fileNames,
                                                                                                                fileOrigins
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Icon
                                                                                                            name="upload"
                                                                                                            size="lg"
                                                                                                            color="white"
                                                                                                        />
                                                                                                        <span>Upload</span>
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <span className="not-authorized">
                                                                        <Icon name="lock" size="lg" color="secondary" />
                                                                        Not authorized to view files
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <div
                                                                className={clsx("evidence__activities", {
                                                                    open: selectedTab === 1,
                                                                    closed: selectedTab !== 1,
                                                                })}
                                                            >
                                                                {permissions.requests.evidences.activity.view ? (
                                                                    <>
                                                                        <div className="title">
                                                                            <span>Activity</span>
                                                                        </div>
                                                                        <div className="container">
                                                                            {hasElements(evidence.activities) || editMode ? (
                                                                                <Timeline className="timeline">
                                                                                    {hasElements(evidence.activities) &&
                                                                                        evidence.activities.map((activity) => (
                                                                                            <TimelineItem
                                                                                                key={activity.id}
                                                                                                className="evidence-activity"
                                                                                            >
                                                                                                <TimelineOppositeContent
                                                                                                    style={{
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        textAlign: "start",
                                                                                                        flex: "none",
                                                                                                        width: "30%",
                                                                                                        justifyContent: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="activity-user">
                                                                                                        {activity.actionUser?.name}
                                                                                                    </span>
                                                                                                    <span className="activity-datetime">
                                                                                                        {dateToFullString(
                                                                                                            activity.actionDatetime
                                                                                                        )}
                                                                                                    </span>
                                                                                                </TimelineOppositeContent>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineConnector />
                                                                                                    <TimelineDot
                                                                                                        variant="outlined"
                                                                                                        color="grey"
                                                                                                        style={{
                                                                                                            boxShadow:
                                                                                                                "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                                                                                                        }}
                                                                                                    >
                                                                                                        {activity.action ===
                                                                                                        ActivityActions.APPROVED ? (
                                                                                                            <Icon
                                                                                                                name="rounded-check"
                                                                                                                size="md"
                                                                                                                color="success"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.APPROVAL_REVOKED ? (
                                                                                                            <Icon
                                                                                                                name="cancel"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.DELETE_DOCUMENT ? (
                                                                                                            <Icon
                                                                                                                name="delete"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                              ActivityActions.ADD_DOCUMENT ||
                                                                                                          activity.action ===
                                                                                                              ActivityActions.ADD_DOCUMENTS ||
                                                                                                          activity.action ===
                                                                                                              ActivityActions.ANALYSIS_ATTACHMENT_ADDED ||
                                                                                                          activity.action ===
                                                                                                              ActivityActions.ANALYSIS_ATTACHMENTS_ADDED ? (
                                                                                                            <Icon
                                                                                                                name="add-file"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.ANALYSIS_ADDED ? (
                                                                                                            <Icon
                                                                                                                name="analyze"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.MARK_RECEIVED ? (
                                                                                                            <Icon
                                                                                                                name="rounded-check"
                                                                                                                size="md"
                                                                                                                color="success"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                              ActivityActions.UNMARK_RECEIVED ||
                                                                                                          activity.action ===
                                                                                                              ActivityActions.REJECTED ? (
                                                                                                            <Icon
                                                                                                                name="cancel"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.COMPLETED ? (
                                                                                                            <Icon
                                                                                                                name="lock"
                                                                                                                size="md"
                                                                                                                color="success"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.REQUESTED_TO_CLIENT ? (
                                                                                                            <Icon
                                                                                                                name="rounded-check"
                                                                                                                size="md"
                                                                                                                color="primary"
                                                                                                            />
                                                                                                        ) : activity.action ===
                                                                                                          ActivityActions.UNREQUESTED_TO_CLIENT ? (
                                                                                                            <Icon
                                                                                                                name="cancel"
                                                                                                                size="md"
                                                                                                                color="secondary"
                                                                                                            />
                                                                                                        ) : (
                                                                                                            <Icon
                                                                                                                name="comment-dots"
                                                                                                                size="md"
                                                                                                                color="primary"
                                                                                                            />
                                                                                                        )}
                                                                                                    </TimelineDot>

                                                                                                    <TimelineConnector />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent
                                                                                                    style={{
                                                                                                        alignContent: "center",
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        justifyContent: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="activity-action">
                                                                                                        {activity.action}
                                                                                                    </span>
                                                                                                    <span className="activity-notes">
                                                                                                        {activity.notes}
                                                                                                    </span>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                        ))}
                                                                                    {editMode &&
                                                                                        permissions.requests.evidences.activity.add &&
                                                                                        evidence.status !== "completed" && (
                                                                                            <TimelineItem className="evidence-activity edit">
                                                                                                <TimelineOppositeContent
                                                                                                    style={{
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        textAlign: "start",
                                                                                                        flex: "none",
                                                                                                        width: "30%",
                                                                                                        justifyContent: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="activity-datetime">
                                                                                                        Add new activity
                                                                                                    </span>
                                                                                                </TimelineOppositeContent>
                                                                                                <TimelineSeparator>
                                                                                                    <TimelineConnector />
                                                                                                    <TimelineDot
                                                                                                        variant="outlined"
                                                                                                        color="grey"
                                                                                                        style={{
                                                                                                            boxShadow:
                                                                                                                "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                                                                                                        }}
                                                                                                    >
                                                                                                        <Icon
                                                                                                            name="comment-dots"
                                                                                                            size="md"
                                                                                                            color="primary"
                                                                                                        />
                                                                                                    </TimelineDot>
                                                                                                    <TimelineConnector />
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent className="add-activity-form">
                                                                                                    <Form
                                                                                                        initialValues={{
                                                                                                            action: "",
                                                                                                            notes: "",
                                                                                                        }}
                                                                                                        validationSchema={Yup.object({
                                                                                                            action: Yup.string()
                                                                                                                .required("Required field")
                                                                                                                .max(100),
                                                                                                            notes: Yup.string()
                                                                                                                .notRequired()
                                                                                                                .max(8000),
                                                                                                        })}
                                                                                                        onSubmit={(...params) =>
                                                                                                            onSubmitActivityHandler(
                                                                                                                ...params,
                                                                                                                evidence
                                                                                                            )
                                                                                                        }
                                                                                                        validateOnChange={false}
                                                                                                    >
                                                                                                        <InputField
                                                                                                            fieldName="action"
                                                                                                            label="Action *"
                                                                                                            maxLength={100}
                                                                                                        />
                                                                                                        <TextareaField
                                                                                                            fieldName="notes"
                                                                                                            label="Notes"
                                                                                                            maxLength={8000}
                                                                                                            rows={3}
                                                                                                        />
                                                                                                    </Form>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                        )}
                                                                                </Timeline>
                                                                            ) : (
                                                                                <>
                                                                                    {!hasElements(evidence.activities) && (
                                                                                        <span className="no-results">
                                                                                            <Icon
                                                                                                name="no-results"
                                                                                                size="lg"
                                                                                                color="secondary"
                                                                                            />
                                                                                            No activity logged yet
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <span className="not-authorized">
                                                                        <Icon name="lock" size="lg" color="secondary" />
                                                                        Not authorized to view activity
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <div
                                                                className={clsx("evidence__analysis", {
                                                                    open: selectedTab === 2,
                                                                    closed: selectedTab !== 2,
                                                                })}
                                                            >
                                                                {permissions.requests.evidences.analysis.view ? (
                                                                    <>
                                                                        <div>
                                                                            <div className="title">
                                                                                <span>Analysis attachments</span>
                                                                            </div>
                                                                            <div className="container">
                                                                                {hasElements(analysisDocs) ? (
                                                                                    <Timeline className="timeline">
                                                                                        {analysisDocs.map((doc) => (
                                                                                            <TimelineItem
                                                                                                key={doc.id}
                                                                                                className="evidence-doc"
                                                                                            >
                                                                                                <TimelineSeparator
                                                                                                    style={{
                                                                                                        justifyContent: "center",
                                                                                                        paddingLeft: "10px",
                                                                                                    }}
                                                                                                >
                                                                                                    {doc.docExtension === ".pdf" ? (
                                                                                                        <SVGIconPDF />
                                                                                                    ) : (
                                                                                                        <SVGIconFile />
                                                                                                    )}
                                                                                                </TimelineSeparator>
                                                                                                <TimelineContent className="doc-content">
                                                                                                    <span
                                                                                                        className="doc-name"
                                                                                                        title={`${doc.docName}${doc.docExtension}`}
                                                                                                    >{`${doc.docName}${doc.docExtension}`}</span>
                                                                                                    <span
                                                                                                        className="doc-user"
                                                                                                        title={doc.storedUser?.name}
                                                                                                    >
                                                                                                        {doc.storedUser?.name}
                                                                                                    </span>
                                                                                                    <span
                                                                                                        className="doc-datetime"
                                                                                                        title={dateToFullString(
                                                                                                            doc.storedDatetime
                                                                                                        )}
                                                                                                    >
                                                                                                        {dateToFullString(
                                                                                                            doc.storedDatetime
                                                                                                        )}
                                                                                                    </span>
                                                                                                    <span className="doc-origin">
                                                                                                        {attachmentOrigins.find(
                                                                                                            (origin) =>
                                                                                                                origin.value === doc.origin
                                                                                                        )?.label || ""}
                                                                                                    </span>
                                                                                                    <div className="doc-actions">
                                                                                                        {permissions.requests.evidences.docs
                                                                                                            .open && (
                                                                                                            <Link
                                                                                                                href={doc.docStorageUrl}
                                                                                                                target="_blank"
                                                                                                                title="Open file"
                                                                                                            >
                                                                                                                <Icon
                                                                                                                    name="open-new-tab"
                                                                                                                    color="secondary"
                                                                                                                    size="sm"
                                                                                                                />
                                                                                                            </Link>
                                                                                                        )}
                                                                                                        {editMode &&
                                                                                                            permissions.requests.evidences
                                                                                                                .docs.delete && (
                                                                                                                <Button
                                                                                                                    small
                                                                                                                    secondary
                                                                                                                    link
                                                                                                                    title="Delete file"
                                                                                                                    onClick={() =>
                                                                                                                        onDeleteDocHandler(
                                                                                                                            evidence,
                                                                                                                            doc
                                                                                                                        )
                                                                                                                    }
                                                                                                                >
                                                                                                                    <Icon
                                                                                                                        name="delete"
                                                                                                                        color="secondary"
                                                                                                                        size="sm"
                                                                                                                    />
                                                                                                                </Button>
                                                                                                            )}
                                                                                                    </div>
                                                                                                </TimelineContent>
                                                                                            </TimelineItem>
                                                                                        ))}
                                                                                    </Timeline>
                                                                                ) : (
                                                                                    <span className="no-results">
                                                                                        <Icon
                                                                                            name="no-results"
                                                                                            size="lg"
                                                                                            color="secondary"
                                                                                        />
                                                                                        No analysis attachments found
                                                                                    </span>
                                                                                )}
                                                                                {editMode && permissions.requests.evidences.docs.add && (
                                                                                    <div className="add-docs">
                                                                                        <div className="add-docs__popup">
                                                                                            <div className="add-docs__popup-body">
                                                                                                {uploader_analysis({
                                                                                                    acceptedFiles: [FileTypes.PDF],
                                                                                                    filesLimit: 5,
                                                                                                })}
                                                                                                {hasElements(filesToUpload_analysis) && (
                                                                                                    <Button
                                                                                                        secondary
                                                                                                        small
                                                                                                        loading={isUploading}
                                                                                                        onClick={() =>
                                                                                                            onUploadHandler(
                                                                                                                evidence,
                                                                                                                filesToUpload_analysis,
                                                                                                                fileNames_analysis,
                                                                                                                fileOrigins_analysis,
                                                                                                                "analysis",
                                                                                                                {
                                                                                                                    single: ActivityActions.ANALYSIS_ATTACHMENT_ADDED,
                                                                                                                    multiple:
                                                                                                                        ActivityActions.ANALYSIS_ATTACHMENTS_ADDED,
                                                                                                                }
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Icon
                                                                                                            name="upload"
                                                                                                            size="lg"
                                                                                                            color="white"
                                                                                                        />
                                                                                                        <span>Upload</span>
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div className="title">
                                                                                <span>Analysis notes</span>
                                                                            </div>
                                                                            <div className="container">
                                                                                {hasElements(evidence.analysis) || editMode ? (
                                                                                    <Timeline className="timeline">
                                                                                        {editMode &&
                                                                                            permissions.requests.evidences.analysis.add &&
                                                                                            evidence.status !== "completed" && (
                                                                                                <TimelineItem className="evidence-analysis edit">
                                                                                                    <TimelineSeparator>
                                                                                                        <TimelineConnector className="connector" />
                                                                                                        <Icon
                                                                                                            name="analyze"
                                                                                                            size="lg"
                                                                                                            color="primary"
                                                                                                        />
                                                                                                        <TimelineConnector className="connector" />
                                                                                                    </TimelineSeparator>
                                                                                                    <TimelineContent className="add-analysis-form">
                                                                                                        <Form
                                                                                                            initialValues={{
                                                                                                                area: user.groups[0]?.name,
                                                                                                                notes: "",
                                                                                                            }}
                                                                                                            validationSchema={Yup.object({
                                                                                                                area: Yup.string()
                                                                                                                    .required(
                                                                                                                        "Required field"
                                                                                                                    )
                                                                                                                    .oneOf(
                                                                                                                        user.groups.map(
                                                                                                                            (g) => g.name
                                                                                                                        )
                                                                                                                    )
                                                                                                                    .max(100),
                                                                                                                notes: Yup.string().required(
                                                                                                                    "Required field"
                                                                                                                ),
                                                                                                            })}
                                                                                                            onSubmit={(values, form) => {
                                                                                                                onSubmitAnalysisHandler(
                                                                                                                    values,
                                                                                                                    form,
                                                                                                                    evidence
                                                                                                                );
                                                                                                            }}
                                                                                                            validateOnChange={false}
                                                                                                        >
                                                                                                            <SelectField
                                                                                                                fieldName="area"
                                                                                                                options={user.groups}
                                                                                                                labelKey={"name"}
                                                                                                                valueKey={"name"}
                                                                                                                label="Area *"
                                                                                                            />
                                                                                                            <Field name="notes">
                                                                                                                {({ field, form }) => {
                                                                                                                    const error =
                                                                                                                        getFieldError({
                                                                                                                            form,
                                                                                                                            field,
                                                                                                                        });

                                                                                                                    return (
                                                                                                                        <RichTextEditor
                                                                                                                            ref={quillRef}
                                                                                                                            error={error}
                                                                                                                            onTextChange={(
                                                                                                                                value
                                                                                                                            ) => {
                                                                                                                                field.onChange(
                                                                                                                                    {
                                                                                                                                        target: {
                                                                                                                                            value,
                                                                                                                                            name: field.name,
                                                                                                                                        },
                                                                                                                                    }
                                                                                                                                );
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    );
                                                                                                                }}
                                                                                                            </Field>
                                                                                                        </Form>
                                                                                                    </TimelineContent>
                                                                                                </TimelineItem>
                                                                                            )}
                                                                                        {hasElements(evidence.analysis) &&
                                                                                            evidence.analysis.map((analysis) => (
                                                                                                <TimelineItem
                                                                                                    key={analysis.id}
                                                                                                    className="evidence-analysis"
                                                                                                >
                                                                                                    <TimelineSeparator>
                                                                                                        <TimelineConnector className="connector" />
                                                                                                        <Icon
                                                                                                            name="analyze"
                                                                                                            size="lg"
                                                                                                            color="secondary"
                                                                                                        />
                                                                                                        <TimelineConnector className="connector" />
                                                                                                    </TimelineSeparator>
                                                                                                    <TimelineContent
                                                                                                        style={{
                                                                                                            alignContent: "center",
                                                                                                            display: "flex",
                                                                                                            flexDirection: "column",
                                                                                                            justifyContent: "center",
                                                                                                        }}
                                                                                                    >
                                                                                                        <span className="analysis-user">
                                                                                                            {analysis.user?.name} -{" "}
                                                                                                            <span className="analysis-area">
                                                                                                                {analysis.area}
                                                                                                            </span>
                                                                                                        </span>
                                                                                                        <span className="analysis-datetime">
                                                                                                            {dateToFullString(
                                                                                                                analysis.datetime
                                                                                                            )}
                                                                                                        </span>

                                                                                                        <span className="analysis-notes">
                                                                                                            <RichTextEditor
                                                                                                                ref={quillRef}
                                                                                                                readOnly
                                                                                                                defaultValue={JSON.parse(
                                                                                                                    analysis.notes
                                                                                                                )}
                                                                                                            />
                                                                                                        </span>
                                                                                                        {/* TODO: implement edit and delete with permissions */}
                                                                                                    </TimelineContent>
                                                                                                </TimelineItem>
                                                                                            ))}
                                                                                    </Timeline>
                                                                                ) : (
                                                                                    <>
                                                                                        {!hasElements(evidence.analysis) && (
                                                                                            <span className="no-results">
                                                                                                <Icon
                                                                                                    name="no-results"
                                                                                                    size="lg"
                                                                                                    color="secondary"
                                                                                                />
                                                                                                No analysis added yet
                                                                                            </span>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <span className="not-authorized">
                                                                        <Icon name="lock" size="lg" color="secondary" /> Not authorized to
                                                                        view the analysis
                                                                    </span>
                                                                )}
                                                            </div>

                                                            <div
                                                                className={clsx("evidence__approvals", {
                                                                    open: selectedTab === 3,
                                                                    closed: selectedTab !== 3,
                                                                })}
                                                            >
                                                                {permissions.requests.evidences.approvals.view ? (
                                                                    <>
                                                                        <div className="title">
                                                                            <span>Approvals</span>
                                                                        </div>
                                                                        <div className="container">
                                                                            {hasElements(evidence.approvals) ? (
                                                                                <Timeline className="timeline">
                                                                                    {evidence.approvals.map((approval) => (
                                                                                        <TimelineItem
                                                                                            key={approval.id}
                                                                                            className="evidence-approval"
                                                                                        >
                                                                                            <TimelineSeparator>
                                                                                                {approval.approved ? (
                                                                                                    <Icon
                                                                                                        name="rounded-check"
                                                                                                        size="lg"
                                                                                                        color="success"
                                                                                                    />
                                                                                                ) : (
                                                                                                    <Icon
                                                                                                        name="dashed-circle"
                                                                                                        size="lg"
                                                                                                        color="secondary"
                                                                                                    />
                                                                                                )}
                                                                                            </TimelineSeparator>
                                                                                            <TimelineContent
                                                                                                style={{
                                                                                                    alignContent: "center",
                                                                                                    display: "flex",
                                                                                                    flexDirection: "column",
                                                                                                    justifyContent: "center",
                                                                                                }}
                                                                                            >
                                                                                                <span className="approval-user">
                                                                                                    {approval.user?.name}
                                                                                                </span>
                                                                                                {approval.approved && (
                                                                                                    <span className="approval-datetime">
                                                                                                        {dateToFullString(
                                                                                                            approval.datetime
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                {!approval.approved &&
                                                                                                    !approval.datetime && (
                                                                                                        <span className="approval-datetime">
                                                                                                            Waiting for approval
                                                                                                        </span>
                                                                                                    )}
                                                                                                {!approval.approved &&
                                                                                                    isDateValid(approval.datetime) && (
                                                                                                        <span className="approval-datetime">
                                                                                                            Revoked
                                                                                                        </span>
                                                                                                    )}
                                                                                            </TimelineContent>
                                                                                        </TimelineItem>
                                                                                    ))}
                                                                                </Timeline>
                                                                            ) : (
                                                                                <span className="no-results">
                                                                                    <Icon name="no-results" size="lg" color="secondary" />
                                                                                    This evidence has not been approved yet
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <span className="not-authorized">
                                                                        <Icon name="lock" size="lg" color="secondary" />
                                                                        Not authorized to view approvals
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            ))}
                        </div>
                    </>
                )
            )}
            <ConfirmDialog {...confirmDialogProps} />
            <FormDialog {...formDialogProps}>
                <Form
                    id="in-dialog-form"
                    onSubmit={formDialogProps.onSubmit}
                    validateOnChange={false}
                    initialValues={{ statusComment: "" }}
                    validationSchema={Yup.object({
                        statusComment: Yup.string().required("Comment is required!").max(200, "Maximum 200 characters"),
                    })}
                    showButtons={false}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextareaField fieldName="statusComment" label="Comment *" rows={3} />
                        </Grid>
                    </Grid>
                </Form>
            </FormDialog>
        </Page>
    );
};

export default CocRequest;
